// extracted by mini-css-extract-plugin
export default {"navIconContainer":"_9uAnlRS","brainLines":"Iff1a7un","enterpriseIcon":"ggAn4CwX","navIconContainerActive":"sMFbadfW"};